import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { API_URL } from "../../../config";


import HeaderThree from "../../../components/header/HeaderThree";
import BlogStyle1 from "../../../components/blog/BlogStyle1";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import search from '../../../assets/Icons9/search.png'

// Highlight component to highlight matched text
export const HighlightText = ({ text = "", highlight = "" }) => {
  if (!highlight.trim()) {
    return <>{text}</>;
  }
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <mark key={i} style={{ backgroundColor: "yellow", padding: 0 }}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
};

const BlogV1 = () => {
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/blog/allblog`);
        setBlogs(data.allBlog || []);
      } catch (error) {
        console.error("Failed to fetch blogs:", error);
      }
    };

    fetchBlogs();
  }, []);

  // Filter blogs by search term in tags, mainheading, or maincontent
  const filteredBlogs = searchTerm
    ? blogs.filter((blog) => {
      const keyword = searchTerm.toLowerCase().trim();

      // Extract tags as array
      let tagsArray = [];
      if (blog.tags) {
        if (Array.isArray(blog.tags)) {
          blog.tags.forEach((tag) => {
            tagsArray.push(...tag.split(",").map((t) => t.trim()));
          });
        } else if (typeof blog.tags === "string") {
          tagsArray = blog.tags.split(",").map((t) => t.trim());
        }
      }

      // Check if keyword in tags, title, or content
      const inTags = tagsArray.some((tag) => tag.toLowerCase().includes(keyword));
      const inTitle = blog.mainheading && blog.mainheading.toLowerCase().includes(keyword);
      const inContent = blog.maincontent && blog.maincontent.toLowerCase().includes(keyword);

      return inTags || inTitle || inContent;
    })
    : blogs;

  return (
    <div className="main-page-wrapper">
      <Helmet>
        <title>Our Blogs || Raiden Studio</title>
      </Helmet>

      <HeaderThree />

      <div className="fancy-hero-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-lg-10 m-auto text-center">
              <h1 className="h2-heading">Our Blogs</h1>
              <p className="font-gordita h1-para">
                You will find here our company news and latest updates.
              </p>

              <div
                className="mt-4"
                style={{ position: "relative", maxWidth: "500px", margin: "0 auto" }}
              >
                <img
                  src={search}
                  alt="Search"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    width: "38px",
                    height: "38px",
                    pointerEvents: "none",
                    opacity: 0.6,
                  }}
                />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search blogs by keyword..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    maxWidth: "500px",
                    margin: "0 auto",
                    padding: "10px 15px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="feature-blog-one blog-page-bg">
        <div className="container">
          <div className="row">
            {/* Pass searchTerm for highlighting */}
            <BlogStyle1 blogs={filteredBlogs} searchTerm={searchTerm} />
          </div>

          <div className="text-center mt-30 md-mt-10">
            <a href="#" className="theme-btn-one h1-para rounded-4">
              Show More
            </a>
          </div>
        </div>
      </div>

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogV1;
